import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ngbd-message-modal',
    template: `
    @if (title||icon) {
      <div class="modal-header">
        <p class="modal-title">@if (!!icon) {
          <fa-icon [icon]="['fas', icon]" class="me-2" [fixedWidth]="true"></fa-icon>
        }{{title}}</p>
      </div>
    }
    <div class="modal-body">
      <p class="text-justify ms-3 me-3 mb-0">{{message}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-pink btn-modal" (click)="close()" autofocus>OK</button>
    </div>`,
    styles: [`
    .modal-header {
      border-bottom: none;
      background-color: var(--lh-navy);
      color: #fff;
    }
    .modal-body, .modal-footer {
      background-color: var(--lh-neutral);
      font-size: 1.1rem;
    }
    .modal-body p {
      line-height: 175%;
      overflow-wrap: break-word;
      white-space: pre-line;
    }
    .modal-footer {
      border-top: none;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdMessageModal {

  @Input() public title: string;
  @Input() public message: string;
  @Input() public icon: string;
  @Input() public callback: () => any;

  constructor(public activeModal: NgbActiveModal) {
  }

  public close(): void {
    if (this.callback) {
      this.callback();
    }
    this.activeModal.close();
  }
}
